import React, { useEffect, useState } from 'react'
import JsonData from "../data/data.json";
import {Contact} from '../components/contact'
import Footer from '../components/footer';


const ContactUsPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  return (
    <>
  
    <Contact data={landingPageData.Header}  />
    <Footer/>
    </>
  )
}

export default ContactUsPage